import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import {
  WEB_COMPONENT_DOWNLOAD_K8S_AGENT,
  WEB_COMPONENT_DOWNLOAD_SECURITY_CONTAINER,
  WEB_COMPONENT_PACKAGES_GRID,
} from '../../../webcomponents.constants';
import { PackagesGridWebComponent } from '../../packagesGrid';
import { Dependencies } from '../../types/dependencies';
import { TemplateState } from '../../../types/common/types';
import { DownloadSecurityContainerWebComponent } from '../../downloadSecurityContainerWindow';
import { DownloadK8sAgentWebComponent } from '../../downloadK8sAgentWindow';

export class PackagesAppView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $packagesGrid: PackagesGridWebComponent;
    $securityContainerWindow: DownloadSecurityContainerWebComponent;
    $k8sAgentWindow: DownloadK8sAgentWebComponent;
  };

  public dependencies: Dependencies;

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $packagesGrid: this.shadow.querySelector(WEB_COMPONENT_PACKAGES_GRID),
      $securityContainerWindow: this.shadow.querySelector(WEB_COMPONENT_DOWNLOAD_SECURITY_CONTAINER),
      $k8sAgentWindow: this.shadow.querySelector(WEB_COMPONENT_DOWNLOAD_K8S_AGENT),
    };
  }

  public buildSuccessView(data: any) {
    if (!this.dom.$packagesGrid.started) {
      this.dom.$packagesGrid.injectDependencies(this.dependencies);
      this.dom.$packagesGrid.start().then().catch(console.error);
    }
  }

  public setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  public removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }
}
